export default __webpack_public_path__ + "static/media/c006-2.626455bf.jpg";